import ArticleCard from '@/components/base/ArticleCard';
import { getFeaturedArticles } from '@/mocks/articles';

export default function FeaturedWorks() {
  const featured = getFeaturedArticles();

  return (
    <section className="py-14 md:py-20 px-4 md:px-6">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
            精选推荐
          </h2>
          <p className="mt-3 text-sm text-foreground-500 max-w-lg mx-auto">
            编辑团队精心挑选的高品质同人作品，每一部都值得细细品味
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-5">
          {featured.map((article) => (
            <ArticleCard key={article.slug} article={article} />
          ))}
        </div>
      </div>
    </section>
  );
}